import angular from 'angular';
import * as $ from 'jquery';

angular.module('webTools').factory('ModalWindow', ['$rootScope', '$compile', '$timeout', 'File', 'Folder', 'Project',
    function ($rootScope, $compile, $timeout, File, Folder, Project) {
        return {
            openConfirmation: function(dialogText, successCallback, cancelCallback) {
                var kendoWindow = $('<div id="wtConfirmation" />').kendoWindow({
                    resizable: false,
                    modal: true,
                    close: function(e) {
                        kendoWindow.data("kendoWindow").destroy();
                    },
                    activate: function() {
                        $('.k-overlay').attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();');

                        $('#wtConfirmation').parent().attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();');
                    }
                });

                kendoWindow.data("kendoWindow")
                    .content('<p style="text-align: center;padding: 5px 10px;">' + dialogText + '</p>' +
                              '<div style="width:100%;text-align:center;">' +
                                '<div class="confirm-ok">Yes</div>' +
                                '<div class="confirm-cancel">No</div>' +
                                '</div>')
                    .center().open();

                    var off = $rootScope.$on('$routeChangeSuccess', function(e, data) {
                        if(kendoWindow.data("kendoWindow")) {
                            kendoWindow.data("kendoWindow").close().destroy();
                        }
                        off();
                    })

                kendoWindow
                    .find(".confirm-ok, .confirm-cancel")
                        .click(function() {
                            if ($(this).hasClass("confirm-ok")) {
                                successCallback();
                            } else if ($(this).hasClass("confirm-cancel")) {
                                if (cancelCallback) { cancelCallback() };
                            }

                             kendoWindow.data("kendoWindow").close().destroy();
                        })
                        .end()
            },
            openNotification: function(dialogText, callback) {
                var kendoWindow = $('<div id="wtNotification" />').kendoWindow({
                    resizable: false,
                    modal: true,
                    close: function(e) {
                        kendoWindow.data("kendoWindow").destroy();
                    },
                    activate: function () {
                        $('.k-overlay').attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();');

                        $('#wtNotification').parent().attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                                       .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();');
                    }
                });

                kendoWindow.data("kendoWindow")
                    .content('<p style="text-align: center;padding: 0 10px;">' + dialogText + '</p>' +
                              '<div style="width:100%;text-align:center;">' +
                                '<div class="confirm-ok">OK</div>' +
                                '</div>')
                    .center().open();

              if (callback) { callback(); }

                kendoWindow
                    .find(".confirm-ok")
                        .click(function() {
                            kendoWindow.data("kendoWindow").close().destroy();
                        })
                        .end()
            },
            restrictWindowDragging: function (windowName) {
                var winObject = $('#' + windowName).data("kendoWindow");

                var windowWrapper = winObject.wrapper,
                    windowPosition = windowWrapper.offset(),
                    shouldOverridePosition = false

                if (windowPosition.top > $(window).height() - windowWrapper.outerHeight()) {
                    shouldOverridePosition = true;
                }

                if (windowPosition.left > $(window).width() - windowWrapper.width()) {
                    shouldOverridePosition = true;
                }

                if (windowPosition.left < 0) {
                    shouldOverridePosition = true;
                }

                if (shouldOverridePosition) {
                    winObject.center();
                    winObject.refresh();
                }
            }
        };
    }
]);

